import { atom, useAtom } from 'jotai';
const atomCurrency = atom('CHF');
export function useCurrency() {
  return useAtom(atomCurrency);
}